/* ── Carrossel das secoes clonadas ────────────────────────────────────────
   A referencia desenha DOIS carrosseis e os dois dependem do JS do tema de
   origem, que nao vem no clone:

   1. A vitrine de produtos usa Splide (`<splide-component>`): 4 cartoes por
      vez no desktop e 2 no celular, setas nas laterais e bolinhas embaixo.
      Sem o JS, o `.splide__track` (overflow:hidden) cortava o resto: a home
      mostrava 4 produtos dos 8 e nao havia como chegar nos outros.

   2. O bloco de depoimentos usa Swiper (`.swiper.preview`): 3 cartoes por vez
      (1,2 no celular), o do MEIO aceso e os vizinhos a 50%, em laco infinito.
      Sem o JS saiam 4 cartoes parados, todos apagados, e as setas (que estao
      na marcacao) nao faziam nada.

   O que as duas bibliotecas fazem e por classe e transform — e a folha colhida
   ja sabe desenhar essas classes (`is-active`, `is-visible`, `is-next`,
   `swiper-slide-active`…). Entao aqui elas sao postas na mao, com a geometria
   MEDIDA no elemento vivo da referencia:

     produtos (1440): trilho 1330, cartao 303 + 40 de folga, 8 slides, 5 paginas
     depoimentos (1440): caixa 1064, cartao 341 + 20, 3 por vista, centrado
     depoimentos  (390): caixa  357, cartao 294 + 20, 1,2 por vista, centrado

   Nao mexe em nenhum outro `.swiper` do clone (os de video e os da coluna da
   PDP tem outra conta e ficam como estao). */

(function () {
  'use strict';

  var MOVEL = '(max-width: 749px)';

  function movel() {
    return window.matchMedia(MOVEL).matches;
  }

  function num(v, padrao) {
    var n = parseFloat(v);
    return isNaN(n) ? padrao : n;
  }

  function largura(el) {
    return el.getBoundingClientRect().width;
  }

  /* o passo e a largura do cartao mais a folga que a folha pos nele */
  function passo(slide, folgaCss) {
    var c = window.getComputedStyle(slide);
    var folga = num(c.marginRight, 0) || num(folgaCss, 0);
    return largura(slide) + folga;
  }

  var SETA = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" ' +
             'height="40" focusable="false"><path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 ' +
             '14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path></svg>';

  /* ── 1. vitrine de produtos (Splide) ──────────────────────────────────── */

  function vitrine(comp) {
    var raiz = comp.querySelector('.splide');
    var trilho = comp.querySelector('.splide__track');
    var lista = comp.querySelector('.splide__list');
    if (!raiz || !trilho || !lista) return;
    if (raiz.classList.contains('is-initialized')) return;

    var slides = Array.prototype.slice.call(lista.children);
    if (slides.length < 2) return;

    var dado = function (nome, padrao) {
      return num(comp.getAttribute('data-' + nome), padrao);
    };
    var cor = comp.getAttribute('data-arrows-color') || '';
    var corDots = comp.getAttribute('data-dots-color') || '';

    raiz.classList.add('splide--slide', 'splide--ltr', 'is-active', 'is-overflow',
                       'is-initialized');
    trilho.classList.add('splide__track--slide', 'splide__track--ltr');
    lista.style.transition = 'transform 400ms cubic-bezier(.25,.72,.51,.96)';

    /* esqueleto de setas e bolinhas, igual ao que o Splide monta. Se o clone
       trouxe a casca vazia da referencia, ela e reaproveitada — criar uma
       segunda deixaria duas fileiras de bolinhas na secao. */
    var caixa = raiz.querySelector('.splide__dots-and-arrows');
    var caixaNova = !caixa;
    if (caixaNova) {
      caixa = document.createElement('div');
      caixa.className = 'splide__dots-and-arrows';
    } else {
      caixa.innerHTML = '';
    }

    var setas = document.createElement('div');
    setas.className = 'splide__arrows splide__arrows--ltr';
    var btn = function (lado, rotulo) {
      var b = document.createElement('button');
      b.className = 'splide__arrow ' + (cor ? 'color-' + cor + ' ' : '') + 'splide__arrow--' + lado;
      b.type = 'button';
      b.setAttribute('aria-label', rotulo);
      b.innerHTML = SETA;
      return b;
    };
    var ant = btn('prev', 'Previous slide');
    var prox = btn('next', 'Next slide');
    setas.appendChild(ant);
    setas.appendChild(prox);

    var dots = document.createElement('ul');
    dots.className = 'splide__pagination splide__pagination--ltr';
    dots.setAttribute('role', 'tablist');

    /* a referencia serve a paginacao antes das setas */
    caixa.appendChild(dots);
    caixa.appendChild(setas);
    if (caixaNova) raiz.appendChild(caixa);

    var i = 0;

    function porVista() {
      return Math.max(1, dado(movel() ? 'slides-mobile' : 'slides-desktop', movel() ? 2 : 4));
    }

    function porPasso() {
      return Math.max(1, dado(movel() ? 'per-move-mobile' : 'per-move-desktop', 1));
    }

    function ultimo() {
      return Math.max(0, slides.length - porVista());
    }

    function montarDots() {
      var n = Math.floor(ultimo() / porPasso()) + 1;
      if (dots.children.length === n) return;
      dots.innerHTML = '';
      for (var k = 0; k < n; k++) {
        var li = document.createElement('li');
        li.setAttribute('role', 'presentation');
        var b = document.createElement('button');
        b.className = 'splide__pagination__page' + (cor || corDots ? ' color-' + (corDots || cor) : '') +
                      ' dots-custom-color';
        b.type = 'button';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Go to slide ' + (k + 1));
        b.dataset.indice = String(k * porPasso());
        li.appendChild(b);
        dots.appendChild(li);
      }
    }

    function pintar() {
      var vista = porVista();
      var p = passo(slides[0], comp.getAttribute('data-gap-desktop'));
      lista.style.transform = 'translateX(' + (-i * p) + 'px)';

      slides.forEach(function (s, k) {
        s.classList.toggle('is-active', k === i);
        s.classList.toggle('is-visible', k >= i && k < i + vista);
        s.classList.toggle('is-prev', k === i - 1);
        s.classList.toggle('is-next', k === i + 1);
      });

      ant.disabled = i <= 0;
      prox.disabled = i >= ultimo();

      Array.prototype.forEach.call(dots.children, function (li, k) {
        var b = li.firstChild;
        var ativo = Math.round(i / porPasso()) === k;
        b.classList.toggle('is-active', ativo);
        b.setAttribute('aria-selected', ativo ? 'true' : 'false');
      });
    }

    function ir(novo) {
      i = Math.max(0, Math.min(ultimo(), novo));
      pintar();
    }

    ant.addEventListener('click', function () { ir(i - porPasso()); });
    prox.addEventListener('click', function () { ir(i + porPasso()); });
    dots.addEventListener('click', function (e) {
      var b = e.target.closest('.splide__pagination__page');
      if (b) ir(num(b.dataset.indice, 0));
    });

    montarDots();
    pintar();

    comp._ewcRecalcular = function () {
      montarDots();
      ir(i);
    };
  }

  /* ── 2. depoimentos (Swiper, centrado e infinito) ─────────────────────── */

  function depoimentos(raiz) {
    var trilho = raiz.querySelector('.swiper-wrapper');
    if (!trilho || raiz.classList.contains('ewc-carrossel-pronto')) return;

    /* a captura pode ter trazido duplicados que o app tinha criado */
    Array.prototype.slice.call(trilho.children).forEach(function (s) {
      if (s.classList.contains('swiper-slide-duplicate')) s.remove();
    });

    var reais = Array.prototype.slice.call(trilho.children);
    if (reais.length < 2) return;

    var ESPACO = 20;
    raiz.classList.add('ewc-carrossel-pronto');

    /* laco infinito: uma copia de cada lado */
    var antes = reais.map(function (s) { return clone(s); });
    var depois = reais.map(function (s) { return clone(s); });
    antes.reverse().forEach(function (s) { trilho.insertBefore(s, trilho.firstChild); });
    depois.forEach(function (s) { trilho.appendChild(s); });

    function clone(s) {
      var c = s.cloneNode(true);
      c.classList.add('swiper-slide-duplicate');
      c.setAttribute('aria-hidden', 'true');
      return c;
    }

    var todos = Array.prototype.slice.call(trilho.children);
    var n = reais.length;
    var i = n;                      /* primeiro slide real */

    /* a folha da secao traz `.preview .swiper-wrapper{overflow:hidden;
       justify-content:space-between;align-items:center}` e a folha da home tem
       um carrossel de CSS puro de uma rodada anterior (`overflow-x:auto` com
       encaixe de rolagem). As duas coisas cortam o cartao vizinho: no elemento
       vivo da referencia o trilho e `overflow:visible` e sem distribuicao. */
    trilho.style.display = 'flex';
    trilho.style.columnGap = '0px';
    trilho.style.gap = '0px';
    trilho.style.overflow = 'visible';
    trilho.style.justifyContent = 'normal';
    trilho.style.alignItems = 'normal';
    trilho.style.scrollSnapType = 'none';

    var pai = raiz.parentElement;
    var setaAnt = pai.querySelector('[class*="-btn-prev-"]');
    var setaProx = pai.querySelector('[class*="-btn-next-"]');
    var paginacao = pai.querySelector('.swiper-pagination');
    /* a captura trouxe a paginacao vazia (o Swiper a enche em tempo de execucao):
       uma bolinha por cartao real, como na referencia */
    if (paginacao && !paginacao.children.length) {
      for (var b = 0; b < n; b++) {
        var bol = document.createElement('span');
        bol.className = 'swiper-pagination-bullet';
        bol.setAttribute('tabindex', '0');
        bol.setAttribute('role', 'button');
        bol.setAttribute('aria-label', 'Go to slide ' + (b + 1));
        paginacao.appendChild(bol);
      }
    }

    function porVista() {
      return movel() ? 1.2 : 3;
    }

    /* larguras como o Swiper calcula: (caixa - folga * (porVista - 1)) / porVista
       — medido na referencia: 1064 e 3 por vista dao 341; 357 e 1,2 dao 294 */
    function medir() {
      var caixa = largura(raiz);
      var vista = porVista();
      var larg = (caixa - ESPACO * (vista - 1)) / vista;
      todos.forEach(function (s) {
        s.style.width = larg + 'px';
        s.style.marginRight = ESPACO + 'px';
        s.style.flex = '0 0 auto';
      });
    }

    /* o deslocamento sai da MEDIDA do cartao ativo, nao de conta de passo: a
       folha do tema de origem mexe em gap e margem, e qualquer conta propria
       erra o centro. Aqui le-se onde o cartao esta agora e empurra-se o
       trilho pela diferenca ate o centro da caixa. */
    function centrar(animar) {
      var atual = 0;
      var m = /matrix\(1, 0, 0, 1, (-?[\d.]+)/.exec(window.getComputedStyle(trilho).transform);
      if (m) atual = parseFloat(m[1]);
      var cx = raiz.getBoundingClientRect();
      var sx = todos[i].getBoundingClientRect();
      var delta = (cx.left + cx.width / 2) - (sx.left + sx.width / 2);
      trilho.style.transition = animar ? 'transform 300ms ease' : 'none';
      trilho.style.transform = 'translate3d(' + (atual + delta) + 'px, 0, 0)';
    }

    function pintar(animar) {
      medir();
      centrar(animar);
      /* o Swiper da referencia NAO poe swiper-slide-visible (a folha usaria
         isso para acender os vizinhos a partir de 1024px, e la eles estao a
         50%). So active / prev / next. */
      todos.forEach(function (s, k) {
        s.classList.toggle('swiper-slide-active', k === i);
        s.classList.toggle('swiper-slide-prev', k === i - 1);
        s.classList.toggle('swiper-slide-next', k === i + 1);
        s.classList.remove('swiper-slide-visible');
      });

      if (paginacao) {
        var reta = ((i - n) % n + n) % n;
        Array.prototype.forEach.call(paginacao.children, function (b, k) {
          b.classList.toggle('swiper-pagination-bullet-active', k === reta);
        });
      }
    }

    function ir(d) {
      i += d;
      pintar(true);
      /* voltou para a copia? reposiciona sem animacao, e o laco nao tem fim */
      window.setTimeout(function () {
        if (i < n) { i += n; pintar(false); }
        else if (i >= n * 2) { i -= n; pintar(false); }
      }, 320);
    }

    if (setaAnt) {
      setaAnt.style.cursor = 'pointer';
      setaAnt.addEventListener('click', function () { ir(-1); });
    }
    if (setaProx) {
      setaProx.style.cursor = 'pointer';
      setaProx.addEventListener('click', function () { ir(1); });
    }
    if (paginacao) {
      paginacao.addEventListener('click', function (e) {
        var k = Array.prototype.indexOf.call(paginacao.children, e.target);
        if (k >= 0) { i = n + k; pintar(true); }
      });
    }

    pintar(false);
    raiz._ewcRecalcular = function () { pintar(false); };
  }

  /* ── Carrossel de avaliacao da coluna da PDP ───────────────────────────
     Marcacao clonada do Splide, com setas e bolinhas ja no HTML. Um slide
     por vista, passo de um, sem laco: a seta da ponta fica desabilitada,
     como no Splide da referencia. */
  function colunaAvaliacao(comp) {
    var raiz = comp.querySelector('.splide');
    var lista = comp.querySelector('.splide__list');
    var caixa = comp.querySelector('.splide__dots-and-arrows');
    if (!raiz || !lista || !caixa) return;
    if (raiz._ewcColuna) return;
    raiz._ewcColuna = true;

    var slides = Array.prototype.slice.call(lista.children);
    if (slides.length < 2) return;

    var ant = caixa.querySelector('.splide__arrow--prev');
    var prox = caixa.querySelector('.splide__arrow--next');
    var dots = Array.prototype.slice.call(caixa.querySelectorAll('.splide__pagination__page'));
    var i = 0;

    lista.style.transition = 'transform 400ms cubic-bezier(.25,.72,.51,.96)';

    function porVista() {
      return Math.max(1, num(comp.getAttribute(movel() ? 'data-slides-mobile' : 'data-slides-desktop'), 1));
    }
    function ultimo() {
      return Math.max(0, slides.length - porVista());
    }
    function pintar() {
      var p = passo(slides[0], comp.getAttribute(movel() ? 'data-gap-mobile' : 'data-gap-desktop'));
      lista.style.transform = 'translateX(' + (-i * p) + 'px)';
      slides.forEach(function (s, k) {
        s.classList.toggle('is-active', k === i);
        s.classList.toggle('is-visible', k >= i && k < i + porVista());
        s.classList.toggle('is-prev', k === i - 1);
        s.classList.toggle('is-next', k === i + 1);
      });
      if (ant) ant.disabled = i <= 0;
      if (prox) prox.disabled = i >= ultimo();
      dots.forEach(function (b, k) {
        b.classList.toggle('is-active', k === i);
        b.setAttribute('aria-selected', k === i ? 'true' : 'false');
        b.tabIndex = k === i ? 0 : -1;
      });
    }
    function ir(novo) {
      i = Math.max(0, Math.min(ultimo(), novo));
      pintar();
    }
    if (ant) ant.addEventListener('click', function () { ir(i - 1); });
    if (prox) prox.addEventListener('click', function () { ir(i + 1); });
    dots.forEach(function (b, k) { b.addEventListener('click', function () { ir(k); }); });

    pintar();
    raiz._ewcRecalcular = function () { pintar(); };
    comp._ewcRecalcular = raiz._ewcRecalcular;
  }

  /* ── 3. tira de videos da coluna (Swiper com slidesPerView auto) ───────
     A referencia monta `new Swiper(.video-slider-…, {slidesPerView:"auto",
     spaceBetween:16})` com uma seta em cada ponta. Sem a biblioteca a tira
     ficava em pe (os tiles empilhados) e as setas, que sao `position:absolute`,
     subiam para o primeiro ancestral posicionado — caiam em cima do bloco do
     Gateproof. Aqui o trilho vira flex, a caixa ganha contexto de posicao e a
     seta anda um tile por clique. */
  function tiraVideos(raiz) {
    var trilho = raiz.querySelector('.swiper-wrapper');
    if (!trilho || raiz.classList.contains('ewc-carrossel-pronto')) return;
    var slides = Array.prototype.slice.call(trilho.children);
    if (!slides.length) return;
    raiz.classList.add('ewc-carrossel-pronto');

    var ESPACO = 16;
    if (getComputedStyle(raiz).position === 'static') raiz.style.position = 'relative';
    raiz.style.overflow = 'hidden';
    trilho.style.display = 'flex';
    trilho.style.gap = ESPACO + 'px';
    trilho.style.transition = 'transform 300ms ease';
    /* a folha clonada ja da a largura do tile (`flex: 0 0 calc(100%/3 - 12px)`);
       so quem nao tem base propria precisa de ajuda, senao o tile cresce
       ate o tamanho do video e a tira fica em pe */
    slides.forEach(function (s) {
      if (getComputedStyle(s).flexBasis === 'auto') s.style.flex = '0 0 auto';
    });

    var pai = raiz.parentElement;
    var setaAnt = pai.querySelector('[class*="-btn-prev-"]');
    var setaProx = pai.querySelector('[class*="-btn-next-"]');
    var i = 0;

    function limite() {
      var sobra = trilho.scrollWidth - largura(raiz);
      return sobra > 0 ? sobra : 0;
    }
    function deslocamento() {
      var x = 0;
      for (var k = 0; k < i && k < slides.length; k++) x += slides[k].getBoundingClientRect().width + ESPACO;
      return Math.min(x, limite());
    }
    function pintar() {
      trilho.style.transform = 'translate3d(' + (-deslocamento()) + 'px, 0, 0)';
      if (setaAnt) setaAnt.style.opacity = i <= 0 ? '.35' : '';
      if (setaProx) setaProx.style.opacity = deslocamento() >= limite() - 1 ? '.35' : '';
    }
    function ir(d) {
      i = Math.max(0, Math.min(slides.length - 1, i + d));
      pintar();
    }
    if (setaAnt) { setaAnt.style.cursor = 'pointer'; setaAnt.addEventListener('click', function () { ir(-1); }); }
    if (setaProx) { setaProx.style.cursor = 'pointer'; setaProx.addEventListener('click', function () { ir(1); }); }

    /* o tile da referencia abre um modal com som; o modal nao veio no clone,
       entao aqui o clique toca o proprio tile (com som) e pausa os outros */
    slides.forEach(function (s) {
      var v = s.querySelector('video');
      if (!v) return;
      s.style.cursor = 'pointer';
      s.addEventListener('click', function () {
        if (v.paused) {
          slides.forEach(function (o) { var ov = o.querySelector('video'); if (ov && ov !== v) ov.pause(); });
          v.muted = false; v.controls = true;
          var p = v.play();
          if (p && p.catch) p.catch(function () { v.muted = true; v.play(); });
        } else { v.pause(); }
      });
    });

    pintar();
    raiz._ewcRecalcular = pintar;
  }

  /* ── 4. video de secao com botao de play proprio ───────────────────────
     Marcacao `internal-video` clonada: <button class="internal-video__play">
     por cima do <video> com poster. No tema de origem quem liga isso e um
     componente do tema; aqui o clique toca o video (com som, caindo para mudo
     se o navegador recusar), esconde o triangulo e volta a aparecer no fim. */
  function videoDeSecao(botao) {
    if (botao.getAttribute('data-ewc-play') === 'pronto') return;
    var caixa = botao.closest('.internal-video, section, .shopify-section') || botao.parentElement;
    var video = caixa && caixa.querySelector('video');
    if (!video) return;
    botao.setAttribute('data-ewc-play', 'pronto');
    var capa = botao.querySelector('.play-button') || botao.querySelector('svg');

    function mostrarCapa(ver) {
      if (capa) capa.style.opacity = ver ? '' : '0';
      botao.style.background = ver ? '' : 'transparent';
    }
    botao.style.cursor = 'pointer';
    botao.addEventListener('click', function (ev) {
      ev.preventDefault();
      if (video.paused || video.ended) {
        document.querySelectorAll('video').forEach(function (o) { if (o !== video) o.pause(); });
        video.muted = false;
        video.controls = true;
        var p = video.play();
        if (p && p.catch) p.catch(function () { video.muted = true; video.play(); });
        mostrarCapa(false);
      } else {
        video.pause();
        mostrarCapa(true);
      }
    });
    video.addEventListener('pause', function () { if (video.ended) mostrarCapa(true); });
    video.addEventListener('ended', function () { mostrarCapa(true); });
  }

  /* ── 4. video que toca ao entrar na tela ───────────────────────────────
     A referencia nao usa o atributo `autoplay` nessas secoes: o script DELA
     chama `play()` quando o bloco entra na tela, e o video roda mudo, em
     silencio, como fundo. O clone nao traz esse script, e o resultado e um
     quadro congelado no primeiro frame — foi o que o operador viu ("os videos
     automaticos que aparecem ao rolar a tela nao estao funcionando").

     Entram aqui so os videos MUDOS de secao clonada que tem fonte. Quem ja
     tem som ligado foi assumido pelo visitante (o botao de play de
     `videoDeSecao` desliga o mudo) e nao e mais tocado na mao. */
  function videosAoRolar() {
    if (!('IntersectionObserver' in window)) return;

    var olho = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        var v = e.target;
        if (!v.muted) return;
        if (e.isIntersecting) {
          var p = v.play();
          if (p && p.catch) p.catch(function () { /* o navegador pode barrar: fica o poster */ });
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.25 });

    document.querySelectorAll('[id^="shopify-section-"] video').forEach(function (v) {
      if (v._ewcRolagem) return;
      if (!v.muted) return;
      var fonte = v.currentSrc || v.getAttribute('src') || v.querySelector('source[src]');
      if (!fonte) return;
      v._ewcRolagem = true;
      v.setAttribute('playsinline', '');
      olho.observe(v);
    });
  }

  /* ── ligacao ───────────────────────────────────────────────────────────── */

  function iniciar() {
    document.querySelectorAll('splide-component').forEach(function (c) {
      try {
        /* o que separa os dois nao e TER o esqueleto: a referencia serve a
           casca VAZIA (`<ul class="splide__pagination"></ul>` e
           `<div class="splide__arrows"></div>`) e o Splide a preenche no
           navegador. Clone com casca vazia e vitrine; so e carrossel da
           coluna quando os controles vieram PRONTOS na marcacao. */
        if (c.querySelector('.splide__arrow') || c.querySelector('.splide__pagination__page')) colunaAvaliacao(c);
        else vitrine(c);
      } catch (e) { /* uma secao nao pode derrubar as outras */ }
    });
    /* a secao de depoimentos aparece como `.swiper.preview` (home e paginas)
       e como `.testimonials-slider-<secao>` (PDP): a marcacao e a mesma */
    document.querySelectorAll('.swiper.preview, [class*="testimonials-slider-"].swiper').forEach(function (s) {
      try { depoimentos(s); } catch (e) { /* idem */ }
    });
    document.querySelectorAll('[class*="video-slider-"].swiper').forEach(function (s) {
      try { tiraVideos(s); } catch (e) { /* idem */ }
    });
    document.querySelectorAll('.internal-video__play, button[class*="internal-video"]').forEach(function (b) {
      try { videoDeSecao(b); } catch (e) { /* idem */ }
    });
    try { videosAoRolar(); } catch (e) { /* idem */ }
  }

  var pendente;
  window.addEventListener('resize', function () {
    window.clearTimeout(pendente);
    pendente = window.setTimeout(function () {
      document.querySelectorAll('splide-component, .swiper.preview, [class*="testimonials-slider-"].swiper, [class*="video-slider-"].swiper').forEach(function (e) {
        if (e._ewcRecalcular) e._ewcRecalcular();
      });
    }, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
